function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M7.222 5.808l16.97 16.97-1.414 1.414-16.97-16.97z"
}), React.createElement("path", {
  d: "M5.808 22.778l16.97-16.97 1.414 1.414-16.97 16.97z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: 30,
    width: 30
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjMwIiB2aWV3Qm94PSIwIDAgMzAgMzAiIHdpZHRoPSIzMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Im0zIDE0aDI0djJoLTI0eiIgdHJhbnNmb3JtPSJtYXRyaXgoLjcwNzEwNjc4IC43MDcxMDY3OCAtLjcwNzEwNjc4IC43MDcxMDY3OCAxNSAtNi4yMTMyMDMpIi8+PHBhdGggZD0ibTMgMTRoMjR2MmgtMjR6IiB0cmFuc2Zvcm09Im1hdHJpeCguNzA3MTA2NzggLS43MDcxMDY3OCAuNzA3MTA2NzggLjcwNzEwNjc4IC02LjIxMzIwMyAxNSkiLz48L2c+PC9zdmc+";
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/assets/svg/icon-close.svg